import { Injectable } from '@angular/core';
import { ScaleTicketHeaderServiceBase } from 'scaletech-tickets';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class ScaleTicketHeaderDataService extends ScaleTicketHeaderServiceBase {

  constructor(http: HttpClient, webApi: WebApiService) {
    super(http, webApi);
  }
}
